module.exports = __webpack_public_path__ + "media/logos/press-logo-home-06ea154f.png";